
import { Component, Vue, Prop } from 'vue-property-decorator'
import AppAlertIcon from '@/components/AppAlertIcon.vue'
import { Status } from '@/utils/alertIconStatus'

@Component({
    components: { AppAlertIcon },
})
export default class RequestUpdateValidation extends Vue {
    @Prop({ default: [] }) public errorList!: string[]
    @Prop({ default: '' }) public error!: string
    @Prop({ default: 0 }) public warningLevel!: number

    public has(error: string) {
        return !this.errorList.includes(error)
    }

    public menuStatus(): Status {
        if (this.has('menu')) {
            return Status.OK
        }
        return Status.ERROR
    }

    public storesStatus(): Status {
        if (this.has('stores')) {
            return Status.OK
        }
        return Status.ERROR
    }

    public legaltermsStatus(): Status {
        if (this.has('legalterms')) {
            return Status.OK
        }
        return Status.ERROR
    }

    public productsStatus(): Status {
        return Status.WARNING
    }
}
